module.exports = __webpack_public_path__ + "img/ec-direct-800x300.00c120b7.png";